import React, {ReactNode} from "react";
import {PagePreloader} from "views/components/preloader";
import {useViewController} from "data/services/locator/locator_hook.service";
import {observer} from "mobx-react";
import {IBootstrapController} from "views/components/bootstrap/bootstrap.controller";
import {Bindings} from "data/constants/bindings";
import {LiveScore} from "views/components/live_score/live_score.component";

export const Bootstrap: React.FC<{children: ReactNode}> = observer(({children}) => {
	const {isReady} = useViewController<IBootstrapController>(Bindings.BootstrapController);
	return isReady ? <LiveScore>{children}</LiveScore> : <PagePreloader />;
});
